

export default {
  transition: 'page',
  data () {
    return {
      letterCount: 0,
      email: '',
      question: '',
      sections: [
        {
          name: 'General',
          icon: require('~/assets/images/icons/icon-bubble-with-question-mark.svg'),
          questions: [
            {
              q: 'What presentation graphics do you offer?',
              a: [
                {
                  type: 'paragraph',
                  text: 'At infoDiagram you can find a wide range of editable diagrams, vector icons and templates in PowerPoint PPTX format. Therefore they can be used in Microsoft Office apps (PowerPoint, Word, Excel) and other applications that can read that open PPTX format (e.g. Google Slides, Keynote, Open Office Impress).'
                },
                {
                  type: 'paragraph',
                  text: 'Check our <a href="/category/industries_slides/" class="link">Categories Page</a>. You\'ll find there universal graphics (e.g. puzzle shapes, hand drawn arrows) and also content-ready topics (e.g. Scrum process, or Logistics icons). Use the search to find visuals for a specific topic.'
                }
              ]
            },
            {
              q: 'How can I get the graphics from your website?',
              a: [
                {
                  type: 'paragraph',
                  text: 'There are two ways you can get PowerPoint slides from us:'
                }, {
                  type: 'info-box-list',
                  classes: 'flex justify-between info-list',
                  infoBoxes: [
                    {
                      title: 'Single purchase',
                      subtitle: '(non-recurring payment)',
                      description: 'Buying a whole presentation slide-deck on a specific topic e.g. Scrum diagrams or Icons bundle.',
                      image: require('~/assets/images/icons/big-download.svg')
                    },
                    {
                      title: 'Subscription access',
                      subtitle: '(recurring payment)',
                      description: 'Possibility to get specific slides from any presentation slide-deck for credits (cancel anytime).',
                      image: require('~/assets/images/icons/two-arrows.svg')
                    }
                  ]
                }, {
                  type: 'paragraph',
                  text: 'In both cases you get lifetime access to the purchased graphics and our support.'
                }, {
                  type: 'paragraph',
                  text: 'You can choose a single-user license or extended license for a team. Contact us to ask about team license details and bonuses.'
                }
              ]
            },
            {
              q: 'How will I get access to the PowerPoint file after the purchase?',
              a: [
                {
                  type: 'paragraph',
                  text: 'After completing the purchase, you\'ll be redirected to the download screen. All your purchases are stored in our slide cloud for wich we provide a lifetime availability. You can access your files with PowerPoint graphics in two ways:'
                }, {
                  type: 'info-box-list',
                  classes: 'flex justify-between info-list with-decorator',
                  decorator: '<img src="~assets/images/icons/faq-icon-01.svg" alt="" class="decorator">',
                  infoBoxes: [
                    {
                      title: 'Whole presentation',
                      description: 'Download the whole presentation slide-deck as one PPTX file.',
                      image: require('~/assets/images/icons/whole-presentation.svg')
                    },
                    {
                      title: 'Subscription access',
                      description: 'Browse and download a specific slide from your purchased slide-deck.',
                      image: require('~/assets/images/icons/single-slide.svg')
                    }
                  ]
                }
              ]
            },
            {
              q: 'Do you offer design services?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes, our team of designers will be glad to do custom design projects for you. We do brand adjustments of slides, graphical face-lifting of your presentation content, or designing new presentation templates or custom icon sets.'
                }, {
                  type: 'paragraph',
                  text: 'See our <a target="_blank" href="https://blog.infodiagram.com/custom-ppt-design" class="link">Design Services</a> web page and contact us to get a quote.'
                }
              ]
            }
          ]
        },
        {
          name: 'Licenses',
          icon: require('~/assets/images/icons/icon-law-paper.svg'),
          questions: [
            {
              q: 'What license do I get with a purchase?',
              a: [
                {
                  type: 'paragraph',
                  text: 'By default, you\'ll get a single-user license which gives you full editing rights. If you want to share the product with your team members or within the company, you have to choose another option in the order form, or you can extend the license later by contacting us.'
                }, {
                  type: 'paragraph',
                  text: 'We offer 3 license types:'
                }, {
                  type: 'info-box-list',
                  classes: 'flex justify-between info-list info-list-3',
                  decorator: '<img src="~assets/images/icons/faq-icon-01.svg" alt="" class="decorator">',
                  infoBoxes: [
                    {
                      title: 'Single',
                      subtitle: '1 User',
                      image: require('~/assets/images/icons/single-user.svg')
                    },
                    {
                      title: 'Small Team',
                      subtitle: '2 to 5 Users',
                      image: require('~/assets/images/icons/team.svg')
                    },
                    {
                      title: 'Company',
                      subtitle: 'Over 5 Users',
                      image: require('~/assets/images/icons/company.svg')
                    }
                  ]
                }
              ]
            }, {
              q: 'Can I share presentations with my colleagues if I get a Single User license?',
              a: [
                {
                  type: 'paragraph',
                  text: 'It depends on the format of the shared presentation. There are two cases:'
                }, {
                  type: 'info-box-list',
                  classes: 'flex justify-between info-list',
                  infoBoxes: [
                    {
                      title: 'Closed Format',
                      description: 'You can freely share presentations saved as "closed" non-editable formats like PDF or bitmap picture.',
                      image: require('~/assets/images/icons/no-editing.svg')
                    },
                    {
                      title: 'Open Format',
                      description: 'To share an "open" editable format like PPTX you need to extend your license. Contact us for details and team bonuses.',
                      image: require('~/assets/images/icons/editing.svg')
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          name: 'Payment',
          icon: require('~/assets/images/icons/icon-payment.svg'),
          questions: [
            {
              q: 'Is payment secure?',
              a: [
                {
                  type: 'image',
                  classes: 'center-block',
                  url: require('~/assets/images/braintree-logo.png')
                }, {
                  type: 'paragraph',
                  text: 'Yes, we use recognized industry standards for secure digital transactions. Payments are handled by a payment processor - Braintree (A PayPal Service). The connection with our site and Braintree is fully encrypted and handled, we don’t see your sensitive data such as card number.'
                }, {
                  type: 'paragraph',
                  text: 'Check the confirmation of our cooperation with Braintree <a class="link" target="_blank" href="https://www.braintreegateway.com/merchants/329rjtkt9r247r4f/verified">here</a>.'
                }, {
                  type: 'paragraph',
                  text: 'Learn more about the Braintree compliance policy <a class="link" target="_blank" href="https://articles.braintreepayments.com/risk-and-security/compliance/overview">here</a>.'
                }
              ]
            }, {
              q: 'Can I get a refund if I\'m not satisfied with the product?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes, we offer a money-back guarantee. If the product doesn\'t meet your needs, contact us, tell your reason and we will provide a refund 100% of the price. Within a refund, you will be requested not to use purchased graphics and remove the files.'
                }
              ]
            }, {
              q: 'Is there a discount for education institutions or NGO?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes, we offer 20% off if you are a teacher or non-profit representative. We will gladly support your activities. Please contact us for details. We may ask for proof of your affiliation.'
                }, {
                  type: 'paragraph',
                  text: 'We also have several free presentation templates for ecology and healthcare good cause use such as <a class="link" href="https://infodiagram.com/s/Climate Change Impact Presentation/">Climate Change Impact Presentation</a> or <a class="link" href="https://infodiagram.com/s/Covid Protection Graphics/">Covid Protection Graphics</a>'
                }
              ]
            }
          ]
        },
        {
          name: 'Using templates',
          icon: require('~/assets/images/icons/icon-settings.svg'),
          questions: [
            {
              q: 'Can I edit the content of the slides?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes, you can freely modify our presentation graphics. That’s why we provide diagrams and icons as vector shapes. You can easily alter their colors, size, position, change texts, and adapt them to your needs.'
                }
              ]
            }, {
              q: 'Can I use my brand colors, not the ones I see on your website?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes, you can freely change the color palette of our slides. When you copy them to your template they will change colors automatically. When copying you have the option to choose the destination color palette or the source color palette with our original colors. If you choose to stick to our design follow those steps:'
                }, {
                  type: 'info-box-shortcuts-list',
                  classes: 'flex justify-between info-list info-list-shortcuts'
                }
              ]
            }, {
              q: 'How to resize an icon or shape keeping its proportions?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Hold a cmd/ctrl key while resizing an icon with the mouse.'
                }, {
                  type: 'info-box-resize-list',
                  classes: 'flex justify-between info-list info-list-shortcuts'
                }
              ]
            }, {
              q: 'Can the product be used with Keynote or Google Slides?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes. our products are designed in Microsoft PowerPoint format that can be opened and edited also in Mac Keynote, Google Slides, or MS Office applications such as Word or Excel. In case of Google Slides and Keynote small changes as fonts replacement can happen.'
                }
              ]
            }, {
              q: 'Can I use the graphics also for my website and my word/pdf presentations?',
              a: [
                {
                  type: 'paragraph',
                  text: 'Yes, you can use the graphics also for your website in form of bitmap pictures and in PDF presentations (generally, in all forms that are not editable). '
                }
              ]
            }
          ]
        }
      ]
    }
  },
  head () {
    return {
      title: 'Frequently Asked Questions about slides and infoDiagram services',
      bodyAttrs: {
        class: 'page-faq page-default'
      }
    }
  },
  methods: {
    copyEmail () {
      navigator.clipboard.writeText('info@infodiagram.com').then(() => {
        this.$toast.success(('Email address copied'))
      })
    },
    getAnswerText (answerFragments) {
      return answerFragments
        .filter(item => item.type === 'paragraph')
        .map(paragaraph => `<p>${paragaraph.text}</p>`)
        .join()
    }
  },
  computed: {
    questions () {
      const questions = []
      this.sections.forEach((section) => {
        questions.push(...section.questions)
      })
      return questions.map(
        question => ({
          question: question.q,
          answer: this.getAnswerText(question.a)
        })
      )
    }
  }
}
